const initialState = {
  diagnoseTooth: [
    // {
    //   toothId: "",
    //   diagnose: "",
    //   toothNo: "",
    //   surface: "",
    //   note: "",
    //   priority: "",
    // },
  ],
  advancedDiagnose: [
    {

      toothNo: "",
      bridge:{
        bridgeType: "",
        lefttooth: 0,
        righttooth: 0,

      },
  
      surface: [
        {
          sid: "",
          color: "",
          diagnoseId: "",
        },
      ],
      rootDiagnoses: [
        {
          diagnose: "",

        },
      ],
      rootVariantDiagnoses: [
        {
          diagnose: "",
          rootNo: "",

        },
      ],


      note: "",
    }
  ],
  investigation: [
    // {
    //   toothId: "",
    //   investigation: "",
    //   toothNo: "",
    //   surface: "",
    //   description: "",
    //   images: [{url,data}],
    // },
  ],
  intraOralSoftTissues: [],
  extraOralExamination: {
    facialAsymmetry: "",
    swellings: "",
    scars: "",
    lymphadenopathy: "",
    other: "",
  },
  occlusalAssessment: {
    incisorRelationship: "",
    canineRelationshipRight: "",
    canineRelationshipLeft: "",
    molarRelationshipRight: "",
    molarRelationshipLeft: "",
    anteriorGuidance: "",
    lateralGuidanceRight: "",
    lateralGuidanceLeft: "",
  },
  bopChart: ["", "", "", "", "", ""],
  prescription: [
    // {
    //   toothId: "",
    //   investigation: "",
    //   toothNo: "",
    //   surface: "",
    //   description: "",
    //   images: [{url,data}],
    // },
  ],
  patientComplain: [
    // {
    //   toothId: "",
    //   investigation: "",
    //   toothNo: "",
    //   surface: "",
    //   description: "",
    //   images: [{url,data}],
    // },
  ],
  pastHistory: [],
  diagnoseNote: "",
  aditionalNote: "",
  makeaction: true,
  teethData: [],
};

export const diagnoseReducer = (state: any = initialState, action: any) => {
  switch (action.type) {
    case "ADD_ADVANCED_DIAGNOSE":
      return {
        ...state,
        advancedDiagnose: action.payload,
      };
    case "UPDATE_ADVANCED_DIAGNOSE":
      // Filter out template objects (objects without actual toothNo values)
      const validAdvancedDiagnose = state.advancedDiagnose.filter(
        (adv: any) => adv.toothNo !== undefined && typeof adv.toothNo === 'number'
      );
      
      const existingIndex = validAdvancedDiagnose.findIndex(
        (adv: any) => adv.toothNo === action.payload.toothNo
      );
      
      if (existingIndex !== -1) {
        // Update existing entry
        return {
          ...state,
          advancedDiagnose: validAdvancedDiagnose.map((adv: any) =>
            adv.toothNo === action.payload.toothNo ? action.payload : adv
          ),
        };
      } else {
        // Add new entry if it doesn't exist
        return {
          ...state,
          advancedDiagnose: [...validAdvancedDiagnose, action.payload],
        };
      }
    case "UPDATE_ADVANCED_DIAGNOSE_BRIDGE": {
      const valid = state.advancedDiagnose.filter(
        (adv: any) => adv.toothNo !== undefined && typeof adv.toothNo === "number"
      );
      const idx = valid.findIndex((adv: any) => adv.toothNo === action.payload.toothNo);
      if (idx !== -1) {
        return {
          ...state,
          advancedDiagnose: valid.map((adv: any) =>
            adv.toothNo === action.payload.toothNo
              ? { ...adv, bridge: { ...adv.bridge, ...action.payload.bridge } }
              : adv
          ),
        };
      }
      return {
        ...state,
        advancedDiagnose: [
          ...valid,
          { toothNo: action.payload.toothNo, bridge: action.payload.bridge },
        ],
      };
    }
    case "UPDATE_ADVANCED_DIAGNOSE_ACTION": {
      const { toothNo, action: actionValue } = action.payload;
      return {
        ...state,
        advancedDiagnose: state.advancedDiagnose.map((adv: any) =>
          adv.toothNo === toothNo ? { ...adv, action: actionValue } : adv
        ),
      };
    }
    case "REMOVE_ADVANCED_DIAGNOSE":
      return {
        ...state,
        advancedDiagnose: state.advancedDiagnose.filter((adv: any) => adv.toothNo !== action.payload),
      };
    case "REMOVE_ADVANCED_DIAGNOSE_SURFACE":
      return {
        ...state,
        advancedDiagnose: state.advancedDiagnose.map((adv: any) =>
          adv.toothNo === action.payload.toothNo ? { ...adv, surface: adv.surface.filter((surface: any) => surface.sid !== action.payload.sid) } : adv
        ),
      };
    case "REMOVE_ADVANCED_DIAGNOSE_ROOT_DIAGNOSE":
      return {
        ...state,
        advancedDiagnose: state.advancedDiagnose.map((adv: any) =>
          adv.toothNo === action.payload.toothNo ? { ...adv, rootDiagnoses: adv.rootDiagnoses.filter((rootDiagnose: any) => rootDiagnose.diagnose !== action.payload.diagnose) } : adv
        ),
      };
    case "REMOVE_ADVANCED_DIAGNOSE_ROOT_VARIANT_DIAGNOSE":
      return {
        ...state,
        advancedDiagnose: state.advancedDiagnose.map((adv: any) =>
          adv.toothNo === action.payload.toothNo ? { ...adv, rootVariantDiagnoses: adv.rootVariantDiagnoses.filter((rootVariantDiagnose: any) => rootVariantDiagnose.diagnose !== action.payload.diagnose) } : adv
        ),
      };
    case "REMOVE_ADVANCED_DIAGNOSE_ROOT_VARIANT_DIAGNOSE_ROOT_NO":
      return {
        ...state,
        advancedDiagnose: state.advancedDiagnose.map((adv: any) =>
          adv.toothNo === action.payload.toothNo ? { ...adv, rootVariantDiagnoses: adv.rootVariantDiagnoses.filter((rootVariantDiagnose: any) => rootVariantDiagnose.rootNo !== action.payload.rootNo) } : adv
        ),
      };
    case "ADD_DIAGNOSE":
      return {
        ...state,
        diagnoseTooth: [...state.diagnoseTooth, action.payload],
      };
    case "ADD_COMPLAIN":
      return {
        ...state,
        patientComplain: [
          ...state.patientComplain,
          { ...action.payload, id: Math.random() },
        ],
      };
    case "ADD_COMPLAINS":
      return {
        ...state,
        patientComplain: action.payload,
      };
    case "ADD_INVESTIGATIONS":
      return {
        ...state,
        investigation: action.payload,
      };
    case "ADD_PRESCRIPTIONS":
      return {
        ...state,
        prescription: action.payload,
      };
    case "ADD_INVESTIGATION_IMAGES":
      return {
        ...state,
        investigation: state.investigation.map((inv: any) =>
          inv._id === action.payload.id
            ? { ...inv, images: action.payload.images }
            : inv
        ),
      };
    case "REMOVE_INVESTIGATION_IMAGES":


      return {
        ...state,
        investigation: state.investigation.map((inv: any) =>
          inv._id === action.payload.invid
            ? {
              ...inv,
              images: inv.images.filter((image: any) => image._id !== action.payload.imageid),
            }
            : inv
        ),
      };

    case "REMOVE_COMPLAIN":

      if (action.payload.hasId === true) {
        const updatedpatientComplain = state.patientComplain.filter(
          (diagnose: any) => diagnose._id !== action.payload._id
        );

        return {
          ...state,
          patientComplain: updatedpatientComplain,
        };
      } else {
        const updatedpatientComplain = state.patientComplain.filter(
          (diagnose: any) => diagnose.id !== action.payload.id
        );
        return {
          ...state,
          patientComplain: updatedpatientComplain,
        };
      }
    case "ADD_PAST_HISTORIES":
      return {
        ...state,
        pastHistory: action.payload ?? [],
      };
    case "ADD_PAST_HISTORY":
      return {
        ...state,
        pastHistory: [...state.pastHistory, action.payload],
      };
    case "REMOVE_PAST_HISTORY":
      return {
        ...state,
        pastHistory: state.pastHistory.filter(
          (item: any) => item._id !== action.payload
        ),
      };
    case "REMOVE_PRESCRIPTION":
      console.log();


      if (action.payload.hasId === true) {
        const updatedprescription = state.prescription.filter(
          (pre: any) => pre._id !== action.payload._id
        );

        return {
          ...state,
          prescription: updatedprescription,
        };
      } else {
        const updatedprescription = state.prescription.filter(
          (pre: any) => pre.id !== action.payload.id
        );
        return {
          ...state,
          prescription: updatedprescription,
        };
      }

    case "ADD_INVESTIGATION":
      return {
        ...state,
        investigation: [
          ...state.investigation,
          { ...action.payload, toothId: Math.random() },
        ],
      };
    case "ADD_PRESCRIPTION":
      return {
        ...state,
        prescription: [
          ...state.prescription,
          { ...action.payload },
        ],
      };
    case "REMOVE_INVESTIGATION": {
      const updatedinvestigation = state.investigation.filter(
        (investigation: any) => investigation._id !== action.payload
      );
      return {
        ...state,
        investigation: updatedinvestigation,
      };
    }
    case "ADD_INTRA_ORAL_SOFT_TISSUES":
      return {
        ...state,
        intraOralSoftTissues: action.payload,
      };
    case "ADD_INTRA_ORAL_SOFT_TISSUE":
      return {
        ...state,
        intraOralSoftTissues: [...state.intraOralSoftTissues, action.payload],
      };
    case "SET_EXTRA_ORAL_EXAMINATION":
      return {
        ...state,
        extraOralExamination: { ...state.extraOralExamination, ...action.payload },
      };
    case "SET_OCCLUSAL_ASSESSMENT":
      return {
        ...state,
        occlusalAssessment: { ...state.occlusalAssessment, ...action.payload },
      };
    case "SET_BOP_CHART":
      return {
        ...state,
        bopChart: Array.isArray(action.payload) ? action.payload : state.bopChart,
      };
    case "REMOVE_INTRA_ORAL_SOFT_TISSUE":
      return {
        ...state,
        intraOralSoftTissues: state.intraOralSoftTissues.filter(
          (item: any) => item._id !== action.payload
        ),
      };
    case "ADD_DIAGNOSE_NOTE":
      return {
        ...state,
        diagnoseNote: action.payload,
      };
    case "ADD_DIAGNOSES":
      return {
        ...state,
        diagnoseTooth: action.payload,
      };
    case "ADD_ADITIONAL_NOTE":
      return {
        ...state,
        aditionalNote: action.payload,
      };
    case "ADD_DIAGNOSES_IMAGE":
      return {
        ...state,
        diagnoseImage: action.payload,
      };
    case "ADD_TREATMENT_IMAGE":
      return {
        ...state,
        treatmentImage: action.payload,
      };
    case "MAKE_ACTION":
      return {
        ...state,
        makeaction: !state.makeaction,
      };
    case "REMOVE_DIAGNOSE":
      const updateddiagnoseTooth = state.diagnoseTooth.filter(
        (diagnose: any) => diagnose.toothId !== action.payload
      );
      return {
        ...state,
        diagnoseTooth: updateddiagnoseTooth,
      };
    case "SET_TEETH_DATA":
      return {
        ...state,
        teethData: action.payload,
      };
    case "UPDATE_TOOTH_DATA":
      const updatedTeethData = state.teethData.map((tooth: any) =>
        tooth.toothNo === action.payload.toothNo
          ? { ...tooth, ...action.payload }
          : tooth
      );
      // If tooth doesn't exist, add it
      const toothExists = state.teethData.some(
        (tooth: any) => tooth.toothNo === action.payload.toothNo
      );
      return {
        ...state,
        teethData: toothExists
          ? updatedTeethData
          : [...state.teethData, action.payload],
      };
    default:
      return state;
  }
};
